import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconWorkflowShapes16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconWorkflowShapes16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m13.303 4.432-1.767-1.768-1.768 1.768L11.536 6.2zm-1.06-2.475a1 1 0 0 0-1.415 0L9.062 3.725A1 1 0 0 0 8.866 4H6.95A2.5 2.5 0 1 0 4 6.95V9H3a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H5V6.95A2.5 2.5 0 0 0 6.95 5h1.995q.05.073.116.139l1.768 1.768q.08.08.171.137V9.05a2.5 2.5 0 1 0 1 0V7.086q.132-.069.243-.18L14.01 5.14a1 1 0 0 0 0-1.414zM11.5 10a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M6 13v-3H3v3zM4.5 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconWorkflowShapes16);
